import React from 'react';
import { SPECIALTIES_OPTIONS, TREATMENTS_OPTIONS, FACILITIES_OPTIONS, ACCREDITATION_OPTIONS } from '../register/options';

export const RegisterMedicalInfo = ({ renderTagSelector }) => (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900 mb-4">Medical Information</h3>
      
      {renderTagSelector('specialties', SPECIALTIES_OPTIONS, 'Medical Specialties *')}
      
      <div className="mt-4">
        {renderTagSelector('treatments', TREATMENTS_OPTIONS, 'Treatments Offered')}
      </div>
      
      <div className="mt-4">
        {renderTagSelector('facilities', FACILITIES_OPTIONS, 'Facilities & Amenities')}
      </div>
      
      <div className="mt-4">
        {renderTagSelector('accreditations', ACCREDITATION_OPTIONS, 'Accreditations')}
      </div>
    </div>
);
